<template>
  <footer class="block bg-white c-black footer">
    <div class="group">

      <router-link :to="{ path: `/` }">
        <module-logo
          :small="true"
        />
      </router-link>

      <ul class="footer__nav">
        <li
          v-for="link in links"
          :key="link.id"
          class="footer__list"
        >
          <module-link
            class="footer__link ttu tdn fw-extrabold link"

            color="secondary"
            :link="link.slug"
            :label="link.name"
            :external="link.external ? link.external : false"
          />
        </li>
      </ul>

    </div>
  </footer>
</template>

<script>
// Modules
import ModuleLink from 'modules/Link';
import ModuleLogo from 'modules/Logo';

// Export
export default {
  name: `ui-footer`,
  components: {
    ModuleLink,
    ModuleLogo,
  },

  data() {
    return {
      links: [
        // {
        //   slug: `faq`,
        //   name: `FAQ`,
        // },
        {
          slug: `privacy`,
          name: `Privacy Policy`,
          external: true,
        },
        {
          slug: `terms`,
          name: `Terms of Service`,
          external: true,
        },
        {
          slug: `understanding-your-report`,
          name: `Understanding your report`,
        },
        {
          slug: `mailto:support@veritooth.com`,
          name: `Contact us`,
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Footer.vue?cffc83c2